import { ButtonHTMLAttributes, ReactNode } from "react";
import { brand } from "../theme";

type Variant = "filled" | "outline";
type Size = "sm" | "md" | "lg";

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
}

const sizeMap: Record<Size, string> = {
  sm: "h-[34px] text-[12px] tracking-[-0.24px]",
  md: "py-2.5 text-[13px]",
  lg: "py-3.5 text-[14px]",
};

const PrimaryButton = ({ children, variant = "filled", size = "lg", fullWidth = true, disabled, className = "", style, ...rest }: PrimaryButtonProps) => {

  const base = "rounded-[6px] font-sansation font-bold tracking-[-0.28px] uppercase transition select-none";
  const widthCls = fullWidth ? "w-full" : "";
  const sizeCls = sizeMap[size];
  const filledStyle = disabled ? { backgroundColor: brand.primaryDisabled, color: brand.textOnPrimary } : { backgroundColor: brand.primary, color: brand.textOnPrimary };
  const outlineStyle = disabled ? { borderColor: brand.primaryDisabled, color: brand.primaryDisabled } : { borderColor: brand.primary, color: brand.primary };
  const variantCls = variant === "filled" ? "hover:brightness-105 active:brightness-95" : "bg-transparent border-2 hover:bg-[rgba(241,90,41,0.08)]";
  const variantStyle = variant === "filled" ? filledStyle : outlineStyle;
  const disabledCls = disabled ? "cursor-not-allowed opacity-100" : "cursor-pointer";

  return (
    <button
      {...rest}
      disabled={disabled}
      className={`${base} ${widthCls} ${sizeCls} ${variantCls} ${disabledCls} ${className}`}
      style={{ ...variantStyle, ...style }}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
